module.exports = __webpack_public_path__ + "img/will-icon.9eda8d6.svg";